import React from 'react'
import classnames from 'classnames'

import '../styles/spinner.scss'

function Spinner({ isScreen, isBig, isWhite, isSmall }) {
  return (
    <div className={classnames('account-spinner', { 'account-spinner--screen': isScreen })}>
      <div
        className={classnames(
          'account-spinner__icon',
          { 'account-spinner__icon--big': isBig || isScreen },
          { 'account-spinner__icon--white': isWhite },
          { 'account-spinner__icon--small': isSmall }
        )}
      />
    </div>
  )
}

export default React.memo(Spinner)
